const api = "https://py.jewelleryservices.co.nz/live/graphql/";
const diamondListingApi = "diamondData";
const diamondDetailApi = "diamondById";
const diamondSearchByReportApi = "diamondByStockorcert";
const diamondAddToCart = "diamondAddToCart";
const ringAddToCart = "ringAddToCart";
const productMetafield = "productMetafield";
const productVariantMetafield = "variantMetafield";

var currencyCode = "{{ cart.currency.iso_code }}";
var currencySymbol = getCurrenySymbol(currencyCode);

/*** get currency symbol start ***/
function getCurrenySymbol(CurrenyCode) {
	var currency_symbol;
	switch (CurrenyCode) {
		// for now we have only single currency*- NZ $
        case 'NZD':
			currency_symbol = 'NZ $';
			break;
		case 'USD':
			currency_symbol = '$';
			break;
        
		default:
			currency_symbol = 'NZ $';
	}

	return currency_symbol;
}
/*** get currency symbol end ***/

/*** addCommas in price start ***/
function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
/*** addCommas in price end ***/

/*** set selected filters for session filters after reloading page start ***/
function setSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {      
	if (input_value == 'price') {
		$('.selected_filter_container').find('li[data-input="price"]').remove();
	}else if (input_value == 'carat') {
		$('.selected_filter_container').find('li[data-input="carat"]').remove();
	}else if (input_value == 'depth') {
		$('.selected_filter_container').find('li[data-input="depth"]').remove();
	}else if (input_value == 'table') {
		$('.selected_filter_container').find('li[data-input="table"]').remove();
	}

	var value = filter_value.split(':');
	if (hasSelectedClass) {
		var html = '';
		html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter_value="' + filter_value + '"><div class="tps_filter_values">' + value[1].trim() + '<span class="tps-pendantbuilder-remove-option"></span></div></li>';
		if ($('#' + value[0] + '_container').length > 0) {
			$('#' + value[0] + '_container').append(html);
		} else {
			var elecontainer = '<ul id="' + value[0] + '_container">';
            //elecontainer += '<span class="tps_applied_filter_lable">' + value[0] + ':</span>';
            elecontainer += '</ul>';
			$('.selected_filter_container').append(elecontainer);
			$('#' + value[0] + '_container').append(html);
		}      
	} else {
		$('.selected_filter_container').find('li[data-filter_value="' + filter_value + '"]').remove();
		if ($('input[value="' + input_value + '"]').length > 0) {
			$('input[value="' + input_value + '"]').prop('checked', false);
		}

		if ($('#' + value[0] + '_container li').length == 0) {
			$('#' + value[0] + '_container').remove();
		}
	}
	if ($('.selected_filter_container li').length > 0) {
		$('.tps_selected_filter_wrapper').show();
	} else {
		$('.tps_selected_filter_wrapper').hide();
	}
}
/*** set selected filters for session filters after reloading page end ***/

/*** tps config function to get urls start ***/
var tps_config = {
	"urls": {        
        "ring_builder_listing": "/collections/engagement-rings",		
		"ringbuilder_loose_diamond": "/pages/ring-builder-natural-diamond-listing",
        "ringbuilder_lab_diamond": "/pages/ring-builder-lab-diamond-listing",
		"ringbuilder_loose_diamond_detail": "/pages/ring-builder-diamond-details",
        "ring_builder_final_page": "/pages/final-ring",
        "loose_diamond": "/pages/loose-natural-diamonds",
        "lab_diamond": "/pages/loose-lab-diamonds",
        "loose_diamond_detail": "/pages/diamond-details",
	}

}
/*** tps config function to get urls end ***/

/*** Diamond Carat Filter Start ***/
var minDiamondCarat = parseFloat($('#diamondMincarat').val());
var maxDiamondCarat = parseFloat($('#diamondMaxcarat').val());
var carat = [];

for (i = minDiamondCarat; i < 1; i = i + 0.01) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 1; i < 2; i = i + 0.10) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
for (i = 2; i < maxDiamondCarat; i = i + 0.15) {
	var dec = i.toFixed(2);
	carat.push(dec);
}
carat.push(maxDiamondCarat);

Shopify.money_format = '&pound;{{amount}}';
var currency_symbol = getCurrenySymbol(currencyCode);


function getClosestNum(num, ar) {
	var i = 0,
		closest, closestDiff, currentDiff;
	if (ar.length) {
		closest = ar[0];
		for (i; i < ar.length; i++) {
			closestDiff = Math.abs(num - closest);
			currentDiff = Math.abs(num - ar[i]);
			if (currentDiff < closestDiff) {
				closest = ar[i];
			}
			closestDiff = null;
			currentDiff = null;
		}
		//returns first element that is closest to number
		return closest;
	}
	//no length
	return false;
}

function get_index(value, array) {
	var pos = 0
	for (i = 0; i < array.length; i++) {
		if (array[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}

function carat_slider_render(start, end, option) { 
    var start2 = getClosestNum(start, carat);
	var end2 = getClosestNum(end, carat);   
	var start1 = get_index(start2, carat);
	var start11 = get_index(start, carat);
	var end11 = get_index(end, carat);
	var end1 = get_index(end2, carat);
  
	var settingSelected = jQuery("#setting").val();

    var pendant_setting = localStorage.getItem("pendant_setting");
    var ring_setting = localStorage.getItem("ring_setting");

    var min_carat = parseFloat($("#diamondMincarat").val()).toFixed(2);
    var max_carat = parseFloat($("#diamondMaxcarat").val()).toFixed(2);

    if (window.location.href.indexOf('ring-builder-natural-diamond-listing') > 0) {
       if(localStorage.getItem("ring_setting") != null){
          var ringsetting_details = jQuery.parseJSON(ring_setting);
          var min_carat = ringsetting_details[0].minimum_carat_total_weight;
          var max_carat = ringsetting_details[0].maximum_carat_total_weight;
          var isSelected = true;
       }
    }
    
	jQuery("#carat-slider").slider({      
		range: true,
		min: 0,
		max: carat.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {  
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			//disable min max slider if setting selected
			if (settingSelected == 1 && (parseFloat(start) > parseFloat(carat[parseInt(ui.values[0])]) || parseFloat(end) < parseFloat(carat[parseInt(ui.values[1])]))) {
				return false;
			}
          
			$("#carat_from").val(carat[parseInt(ui.values[0])] + ' ct.');
			$('#carat_left_hidden').val(carat[parseInt(ui.values[0])]);
			$('#carat_to').val(carat[parseInt(ui.values[1])] + ' ct.');
			$('#carat_right_hidden').val(carat[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
            emptyResultDiv();
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}			

			if (option) {  
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');               
                      
                graphqlDataCall();
    			               
			}
           
		}

	});

    
    start = start ? start : minDiamondCarat;
    $("#carat_from").val(start + ' ct.');
    $("#carat_to").val(end + ' ct.');
    $('#carat_left_hidden').val(start);
    $('#carat_right_hidden').val(end);    
}


function replace_carat_from() {

	var min_carat_value = minDiamondCarat;
 
	var settingSelected = jQuery("#setting").val();
  

	if (jQuery('#carat_from').val() == '') {
		var value = parseFloat(jQuery('#carat_left_hidden').val()).toFixed(2);
		jQuery('#carat_from').val(parseFloat(value).toFixed(2) + ' ct.');
		return false;
	} else {
		var hidden_carat_value = parseFloat($('#carat_left_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_from').val()).toFixed(2);
	}
	
	var value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_to').val());
	if (isNaN(value) != false) {
		var value = parseFloat(minDiamondCarat).toFixed(2);
		alert("Please enter value in number");
		jQuery('#carat_from').val(value + ' ct.');
	} else if (value > value1) {
		alert('Incorrect carat range!');
		$('#carat_from').val(parseFloat(hidden_carat_value).toFixed(2) + ' ct.');
		return false;
	} else if (carat_value < min_carat_value) {
		alert('Incorrect carat range!');
		$('#carat_from').val((parseFloat(min_carat_value).toFixed(2)) + " ct.");
		carat_slider_render(min_carat_value, value1, true);
		return false;
	} else if (settingSelected == 1 && (hidden_carat_value > carat_value)) {
		alert('selected setting can match with diamond greater than ' + carat_value);
		jQuery('#carat_from').val(hidden_carat_value + " ct.");
		return false;
	}
	$('#carat_left_hidden').val(value);
	$('#carat_right_hidden').val(value1);

	carat_slider_render(value, value1, true);

}

function replace_carat_to() {
	var max_carat_value = parseFloat(maxDiamondCarat).toFixed(2);
	var settingSelected = jQuery("#setting").val();
	if (jQuery('#carat_to').val() == '') {
		var value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		jQuery('#carat_to').val(parseFloat(value).toFixed(2) + ' ct.');
		return false;
	} else {
		var hidden_carat_value = parseFloat(jQuery('#carat_right_hidden').val()).toFixed(2);
		var carat_value = parseFloat(jQuery('#carat_to').val()).toFixed(2);
	}

	value = carat_value;
	var carat_value1_comma = value;
	value = carat_value1_comma;

	var value1 = parseFloat($('#carat_from').val());
    
	if (isNaN(value) != false) {
		var value = parseFloat(maxDiamondCarat).toFixed(2);
		alert("Please enter value in number");
		jQuery('#carat_to').val(value + ' ct.');
	} else if (parseFloat(value) > parseFloat(max_carat_value)) {
		alert('Incorrect carat range!');
		jQuery('#carat_to').val(hidden_carat_value + " ct.");
		return false;
	} else if (value1 > value) {
		alert('Incorrect carat range!');
		$('#carat_to').val(hidden_carat_value + ' ct.');
		return false;
	}else if (settingSelected == 1 && (hidden_carat_value < carat_value)) {
		alert('Selected setting can match with diamond less than ' + carat_value);
		jQuery('#carat_to').val(hidden_carat_value + " ct.");
		return false;
	}
   
	$('#carat_right_hidden').val(value);
	$('#carat_left_hidden').val(value1);

	carat_slider_render(value1, value, true);
}
/*** Diamond Carat Filter End ***/

/*** Diamond Price Filter End ***/
var price = [];
var minDiamondPrice = $('#diamondMinprice').val();
var maxDiamondPrice = $('#diamondMaxprice').val();

for (var i = parseFloat(minDiamondPrice); i < 7000; i = i + 25) {
	price.push(i);
};

for (var i = 7000; i < parseFloat(maxDiamondPrice); i = i + 500) {
	price.push(i);
};

price.push(parseInt(maxDiamondPrice));

function addCommas(price) {
	price += '';
	x = price.split('.');
	x1 = x[0];
	x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}


var diamondMinprice = $('#diamondMinprice').val();
var diamondMaxprice = $('#diamondMaxprice').val();

function price_slider_render(start, end, option) {
  
   jQuery('#price-slider').slider({
       range: true,
       values: [start, end],
       min: Number(diamondMinprice),
       max: Number(diamondMaxprice),
       step: 1,
       slide: function (event, ui) {
        emptyResultDiv();
         
         if ((ui.values[0]) >= (ui.values[1])) {
           return false;
         }
         jQuery("#price_left_hidden").val(ui.values[0]);
         jQuery("#price_right_hidden").val(ui.values[1]);
         jQuery('#price_from').val(currencySymbol + addCommas(ui.values[0]));
         jQuery('#price_to').val(currencySymbol + addCommas(ui.values[1]));

       }, change: function (event, ui) {
         
         if(option) {
           emptyResultDiv();
           
           jQuery("#price_left_hidden").val(ui.values[0]);
           jQuery("#price_right_hidden").val(ui.values[1]);
           jQuery('#price_from').val(currencySymbol + addCommas(ui.values[0]));
           jQuery('#price_to').val(currencySymbol + addCommas(ui.values[1]));
           jQuery('#page_no').val(1);
    	   jQuery('#pagination').val('');  
           
           graphqlDataCall();
           
         }
       }
     });

    var start_num = parseInt(start);
	var end_num = parseInt(end);

	var start_dec = start_num.toFixed(0);
	var end_dec = end_num.toFixed(0);

	jQuery('#price_left_hidden').val(start_dec);
	jQuery('#price_right_hidden').val(end_dec);
	jQuery('#price_from').val(currency_symbol + " " + addCommas(start_dec));
	jQuery('#price_to').val(currency_symbol + " " + addCommas(end_dec));
}

function get_priceindex(value) {
	var pos = 0
	for (i = 0; i < price.length; i++) {
		if (price[i] == value) {
			pos = i;
			break;
		}
	}
	return pos;
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});

$("#price_from").keypress(function(e) {
	//if the letter is not digit then display error and don't type anything
	if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
		return false;
	}
});
/*** Price Validation End ***/

function replace_price_to() {

	if (jQuery('#price_to').val() == '') {
		var value = parseFloat(jQuery('#price_right_hidden').val());
		jQuery('#price_to').val(currency_symbol + " " + numberWithCommas(value.toFixed(0)));
		return false;
	} else {
		var value = jQuery('#price_to').val();
	}

	var value1 = jQuery('#price_from').val();
	value = value.replace(/[^\d\.]/g, '');
	value1 = value1.replace(/[^\d\.]/g, '');

	value = parseInt(value);
	value1 = parseInt(value1);

	if (isNaN(value) != false) {
		var value = maxDiamondPrice;
		alert("Please enter value in number");
		jQuery('#1000000').val(currency_symbol + value);
	} else if (value > maxDiamondPrice) {        
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
		jQuery('#price_to').val(currency_symbol + "" + numberWithCommas(valLimit.toFixed(0)));
		return false;
	} else if (value1 > value) {      
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_right_hidden').val());
		jQuery('#price_to').val(currency_symbol + "" + numberWithCommas(valLimit.toFixed(0)));
		return false;
	} else if (value1 == '') {
		jQuery('#price_from').val(value1);
	}

	jQuery('#price_right_hidden').val(value.toFixed(0));
	jQuery('#price_left_hidden').val(value1.toFixed(0));
	price_slider_render(value1, value, true);

}

function replace_price_from() {
	if (jQuery('#price_from').val() == '') {
		var value = parseFloat(jQuery('#price_left_hidden').val());
		jQuery('#price_from').val(currency_symbol + "" + numberWithCommas(value.toFixed(0)));
		return false;
	} else {
		var value = jQuery('#price_from').val();
	}
	var value1 = jQuery('#price_to').val();

	value = value.replace(/[^\d\.]/g, '');
	value1 = value1.replace(/[^\d\.]/g, '');
	value = parseInt(value);
	value1 = parseInt(value1);

	if (isNaN(value) != false) {
		var value = minDiamondPrice;
		alert("Please enter value in number");
		jQuery('#price_from').val(currency_symbol + value);
	} else if (value < minDiamondPrice) {
		alert('Incorrect price range!');
		var valLimit = parseFloat(jQuery('#price_left_hidden').val());
		jQuery('#price_from').val(currency_symbol + "" + numberWithCommas(valLimit.toFixed(0)));
		return false;
	} else if (value > value1) {
		alert('Incorrect price range!');
		price_slider_render(price[0], value1, true);
		return false;
	}

	jQuery('#price_left_hidden').val(value.toFixed(0));
	jQuery('#price_right_hidden').val(value1.toFixed(0));
	price_slider_render(value, value1, true);

}
/*** Diamond Price Filter End ***/

/*** Diamond Depth Filter Start ***/
var depth = [];

for (i = 45; i < 90; i = i + 0.10) {
	var dec = i.toFixed(2);
	depth.push(dec);
}

var min_depth_filter = 45.00;
var max_depth_filter = 90.00;

function depth_slider_render(start, end, option) {
 
	var start2 = getClosestNum(start, depth);
	var end2 = getClosestNum(end, depth);
	var start1 = get_index(start2, depth);
	var start11 = get_index(start, depth);
	var end11 = get_index(end, depth);
	var end1 = get_index(end2, depth);
  
	jQuery("#depth-slider").slider({
		range: true,
		min: 0,
		max: depth.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
			$('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}	

			if (option) {
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');	

                $("#depth_from").val(depth[parseInt(ui.values[0])] + '%');
    			$('#depth_left_hidden').val(depth[parseInt(ui.values[0])]);
    			$('#depth_to').val(depth[parseInt(ui.values[1])] + '%');
    			$('#depth_right_hidden').val(depth[parseInt(ui.values[1])]);

                graphqlDataCall();
                   			
            }
             
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#depth_from").val(Start_limit.toFixed(2) + '%');
	$("#depth_to").val(End_limit.toFixed(2) + '%');
	$('#depth_left_hidden').val(start);
	$('#depth_right_hidden').val(end);
}

function replace_depth_from() {

	var min_depth_value = 45.00;

	if (jQuery('#depth_from').val() == '') {
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_from').val());
		var hidden_depth_value = $('#depth_left_hidden').val();
	}
	
	var value = depth_value;
	
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_to').val());
	
	if (isNaN(value) != false) {
		var value = 45.00;
		alert("Please enter value in number");
		jQuery('#depth_from').val(value + '%');
	} else if (value > value1) {
		alert('Incorrect depth range!');
		var value = parseFloat(jQuery('#depth_left_hidden').val());
		jQuery('#depth_from').val((value.toFixed(2)) + '%');
		return false;
	} else if (depth_value < min_depth_value) {
		alert('Incorrect depth range!');
		$('#depth_from').val(min_depth_value + "%");
		depth_slider_render(min_depth_value, value1, true);
		return false;
	}

	$('#depth_left_hidden').val(value);
	$('#depth_right_hidden').val(value1);

	depth_slider_render(value, value1, true);
}

function replace_depth_to() {

	var max_depth_value = 90;

	if (jQuery('#depth_to').val() == '') {
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var depth_value = parseFloat(jQuery('#depth_to').val());
		var hidden_depth_value = $('#depth_right_hidden').val();
	}	
	value = depth_value;
	var depth_value1_comma = value;
	value = depth_value1_comma;

	var value1 = parseFloat($('#depth_from').val());

	if (isNaN(value) != false) {
		var value = 90.00;
		alert('Please enter value in number');
		jQuery('#depth_to').val(value + '%');
	} else if (value1 > value) {
		alert('Incorrect depth range!');
		var value = parseFloat(jQuery('#depth_right_hidden').val());
		jQuery('#depth_to').val((value.toFixed(2)) + '%');
		return false;
	} else if (value > max_depth_value) {
		alert('Incorrect depth range!');
		$('#depth_to').val(max_depth_value + "%");
		depth_slider_render(value1, max_depth_value, true);
		return false;
	}

	$('#depth_right_hidden').val(value);
	$('#depth_left_hidden').val(value1);

	depth_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/

/*** Diamond Table Filter Start ***/
var table = [];

for (i = 45; i < 90; i = i + 0.10) {
	var dec = i.toFixed(2);
	table.push(dec);
}

var min_table_filter = 45.00;
var max_table_filter = 90.00;

function table_slider_render(start, end, option) {
	var start2 = getClosestNum(start, table);
	var end2 = getClosestNum(end, table);
	var start1 = get_index(start2, table);
	var start11 = get_index(start, table);
	var end11 = get_index(end, table);
	var end1 = get_index(end2, table);

	jQuery("#table-slider").slider({
		range: true,
		min: 0,
		max: table.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#table_from").val(table[parseInt(ui.values[0])] + '%');
			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
			$('#table_to').val(table[parseInt(ui.values[1])] + '%');
			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}
			
			if (option) {
				if (option == true) {
					jQuery('#page_no').val(1);
					jQuery('#pagination').val('');					

                    $("#table_from").val(table[parseInt(ui.values[0])] + '%');
        			$('#table_left_hidden').val(table[parseInt(ui.values[0])]);
        			$('#table_to').val(table[parseInt(ui.values[1])] + '%');
        			$('#table_right_hidden').val(table[parseInt(ui.values[1])]);
                 
                    graphqlDataCall();
				}


			}
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#table_from").val(Start_limit.toFixed(2) + '%');
	$("#table_to").val(End_limit.toFixed(2) + '%');

	$('#table_left_hidden').val(start);
	$('#table_right_hidden').val(end);
}

function replace_table_from() {

	var min_table_value = 45;

	if (jQuery('#table_from').val() == '') {
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_from').val());
		var hidden_table_value = $('#table_left_hidden').val();
	}
	
	var value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_to').val());
	
	if (isNaN(value) != false) {
		var value = 45.00;
		alert('Please enter value in number');
		jQuery('#table_from').val(value + '%');
	} else if (value > value1) {
		alert('Incorrect table range!');
		var value = parseFloat(jQuery('#table_left_hidden').val());
		jQuery('#table_from').val((value.toFixed(2)) + '%');
		return false;
	} else if (table_value < min_table_value) {
		alert('Incorrect table range!');
		$('#table_from').val(min_table_value + "%");
		table_slider_render(min_table_value, value1, true);
		return false;
	}

	$('#table_left_hidden').val(value);
	$('#table_right_hidden').val(value1);

	table_slider_render(value, value1, true);
}

function replace_table_to() {

	var max_table_value = 90;

	if (jQuery('#table_to').val() == '') {
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(2)) + '%');
		return false;
	} else {
		var table_value = parseFloat(jQuery('#table_to').val());
		var hidden_table_value = $('#table_right_hidden').val();
	}

	value = table_value;
	var table_value1_comma = value;
	value = table_value1_comma;

	var value1 = parseFloat($('#table_from').val());
	
	if (isNaN(value) != false) {
		var value = 90.00;
		alert('Please enter value in number');
		jQuery('#table_to').val(value + '%');
	} else if (value1 > value) {
		alert('Incorrect table range!');
		var value = parseFloat(jQuery('#table_right_hidden').val());
		jQuery('#table_to').val((value.toFixed(2)) + '%');
		return false;
	} else if (value > max_table_value) {
		$('#table_to').val(max_table_value + "%");
		table_slider_render(value1, max_table_value, true);
		return false;
	}

	$('#table_right_hidden').val(value);
	$('#table_left_hidden').val(value1);

	table_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/

/*** Diamond Depth Filter Start ***/
var ratio = [];

for (i = 0.5; i < 3.10; i = i + 0.01) {
	var dec = i.toFixed(2);
	ratio.push(dec);
}

var min_ratio_filter = 0.5;
var max_ratio_filter = 3;

function ratio_slider_render(start, end, option) {
 
	var start2 = getClosestNum(start, ratio);
	var end2 = getClosestNum(end, ratio);
	var start1 = get_index(start2, ratio);
	var start11 = get_index(start, ratio);
	var end11 = get_index(end, ratio);
	var end1 = get_index(end2, ratio);
  
	jQuery("#ratio-slider").slider({
		range: true,
		min: 0,
		max: ratio.length - 1,
		values: [start1, end1],
		slide: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}

			$("#ratio_from").val(ratio[parseInt(ui.values[0])]);
			$('#ratio_left_hidden').val(ratio[parseInt(ui.values[0])]);
			$('#ratio_to').val(ratio[parseInt(ui.values[1])]);
			$('#ratio_right_hidden').val(ratio[parseInt(ui.values[1])]);
		},
		change: function(event, ui) {
			emptyResultDiv();
          
			if ((ui.values[0] > ui.values[1])) {
				return false;
			}	

			if (option) {
				jQuery('#page_no').val(1);
				jQuery('#pagination').val('');	

                $("#ratio_from").val(ratio[parseInt(ui.values[0])]);
    			$('#ratio_left_hidden').val(ratio[parseInt(ui.values[0])]);
    			$('#ratio_to').val(ratio[parseInt(ui.values[1])]);
    			$('#ratio_right_hidden').val(ratio[parseInt(ui.values[1])]);
                
    			graphqlDataCall();
            }
               
		}

	});

	var Start_limit = parseFloat(start);
	var End_limit = parseFloat(end);

	$("#ratio_from").val(Start_limit.toFixed(2));
	$("#ratio_to").val(End_limit.toFixed(2));
	$('#ratio_left_hidden').val(start);
	$('#ratio_right_hidden').val(end);
}

function replace_ratio_from() {

	var min_ratio_value = 0.5;

	if (jQuery('#ratio_from').val() == '') {
		var value = parseFloat(jQuery('#ratio_left_hidden').val());
		jQuery('#ratio_from').val((value.toFixed(2)));
		return false;
	} else {
		var ratio_value = parseFloat(jQuery('#ratio_from').val());
		var hidden_ratio_value = $('#ratio_left_hidden').val();
	}
	
	var value = ratio_value;
	
	var ratio_value1_comma = value;
	value = ratio_value1_comma;

	var value1 = parseFloat($('#ratio_to').val());
	
	if (isNaN(value) != false) {
		var value = 0.5;
		alert("Please enter value in number");
		jQuery('#ratio_from').val(value);
	} else if (value > value1) {
		alert('Incorrect ratio range!');
		var value = parseFloat(jQuery('#ratio_left_hidden').val());
		jQuery('#ratio_from').val((value.toFixed(2)));
		return false;
	} else if (ratio_value < min_ratio_value) {
		alert('Incorrect ratio range!');
		$('#ratio_from').val(min_ratio_value);
		ratio_slider_render(min_ratio_value, value1, true);
		return false;
	}

	$('#ratio_left_hidden').val(value);
	$('#ratio_right_hidden').val(value1);

	ratio_slider_render(value, value1, true);
}

function replace_ratio_to() {

	var max_ratio_value = 3;

	if (jQuery('#ratio_to').val() == '') {
		var value = parseFloat(jQuery('#ratio_right_hidden').val());
		jQuery('#ratio_to').val((value.toFixed(2)));
		return false;
	} else {
		var ratio_value = parseFloat(jQuery('#ratio_to').val());
		var hidden_ratio_value = $('#ratio_right_hidden').val();
	}	
	value = ratio_value;
	var ratio_value1_comma = value;
	value = ratio_value1_comma;

	var value1 = parseFloat($('#ratio_from').val());

	if (isNaN(value) != false) {
		var value = 3;
		alert('Please enter value in number');
		jQuery('#ratio_to').val(value);
	} else if (value1 > value) {
		alert('Incorrect ratio range!');
		var value = parseFloat(jQuery('#ratio_right_hidden').val());
		jQuery('#ratio_to').val((value.toFixed(2)));
		return false;
	} else if (value > max_ratio_value) {
		alert('Incorrect ratio range!');
		$('#ratio_to').val(max_ratio_value);
		ratio_slider_render(value1, max_ratio_value, true);
		return false;
	}

	$('#ratio_right_hidden').val(value);
	$('#ratio_left_hidden').val(value1);

	ratio_slider_render(value1, value, true);
}
/*** Diamond Depth Filter End ***/

/***Diamond sorting Filter Start ***/
function sorting_data(sorting, className) {
    emptyResultDiv();
  
	var sortorder = '';
	var clas = className;

	jQuery('.datagrid-sort').each(function() {
		if (jQuery(this).hasClass('fa-angle-up')) {
			jQuery(this).removeClass('fa-angle-up').addClass('fa-angle-down');
		}
	});

	if ((mySelection[1] == sorting) && (mySelection[2] == 'asc')) {
		sortorder = 'desc';
		jQuery(clas).find('i').removeClass('fa-angle-down').addClass('fa-angle-up');
	} else {
		sortorder = 'asc';
		jQuery(clas).find('i').addClass('fa-angle-down').removeClass('fa-angle-up');
	}

    //grid view
    var sort_value = ''+sorting+'_'+sortorder;      
  
    var sort_text = jQuery('.'+sort_value).attr('value'); 
    console.log(sort_value);
     
    jQuery('.sortvaluename').text(sort_text);  
  
	jQuery('#sort_call').val(sorting);
	jQuery('#sort_dir').val(sortorder);


	mySelection[1] = jQuery('#sort_call').val();
	mySelection[2] = jQuery('#sort_dir').val();
 
	jQuery('#page_no').val(1);
	jQuery('#pagination').val('');
	graphqlDataCall();
}
/*** Diamond sorting Filter End ***/

/*** Diamond Info Popoup Open Start ***/ 
jQuery(document).on('click','.tps_diamondlist_detail_icon',function(e){  
  var field_title = jQuery(this).attr("data-field");
  jQuery(".tps_diamond_field_"+field_title).addClass("tps_popoup_show");  
});
/*** Diamond Info Popoup Open End ***/

/*** Diamond Info Popoup Close Start ***/ 
function popoup_close(field_title){
  jQuery(".tps_diamond_field_"+field_title).removeClass("tps_popoup_show");
}
/*** Diamond Info Popoup Close End ***/

/*** Diamond Info Popoup Close Outer Click Start ***/
jQuery(document).on('click','.tps_popoup_show',function(e){
  //var field_title = jQuery(this).attr("data-field");
  var container = $(".tps_diamond_field_popup_section"); //diamond info container
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){      
    jQuery(".tps_diamond_field_popup_wrapper").removeClass("tps_popoup_show");
  }
});
/*** Diamond Info Popoup Close Outer Click End ***/

/*** Capitalized First Letter From String Start ***/
function capitalizeFirstLetter(str){
  return str.replace(/(?:^|\s)\w/g, function(match) {
        return match.toUpperCase();
    });
}
/*** End ***/

/*** Enquire About This Diamond Popup Code Start ***/
  jQuery(document).on('click','.tps_enquire_btn',function(){    
    jQuery(".tps_enquire_diamond_popup").addClass("tps_form_popoup_show");
  });
/*** End ***/

/*** Request Certificatation Popup Code Start ***/
jQuery(document).on('click','.tps_request_certification_button',function(){ 
  jQuery(".tps_request_certificate_popup").addClass("tps_form_popoup_show");
});
/*** End ***/

/*** Enquire About This Ring Popup Code Start ***/
jQuery(document).on('click','.tps_enquire_ring_button',function(){ 
  jQuery('body').addClass("tps_body_no_scroll_effect");
  jQuery(".tps_enquire_diamond_ring_popup").addClass("tps_form_popoup_show");
});
/*** End ***/

/*** Popup Close Code Start ***/
function popoup_form_close(data_popup){
  if(data_popup == 'enquire_diamond_ring'){
    $(".tps_popup_right_section_message").hide();
    $(".tps_popup_body").show();    
  }
  jQuery('body').removeClass("tps_body_no_scroll_effect");
  jQuery(".tps_"+data_popup+"_popup").removeClass("tps_form_popoup_show"); 
}
/*** End ***/

/*** Diamond Info Popoup Close Outer Click Start ***/
jQuery(document).on('click','.tps_form_popoup_show',function(e){
  var container = $(".tps_popup_form"); //diamond info container
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){      
    jQuery(".tps_form_popoup").removeClass("tps_form_popoup_show");
  }
});
/*** Diamond Info Popoup Close Outer Click End ***/

/*** White & Fancy Colour Tab Filters Functionality ***/
jQuery(document).on('click','.tps_filter_tabs',function(e){
  var filter_type = jQuery(this).attr("data-type");
  var search_type = jQuery('#dia_searchtype').val();

  jQuery(".tps_filter_tabs").removeClass('active');
  jQuery(".tps_filter_tab_"+filter_type).addClass('active');
  
  jQuery(".tps_colour_filters").hide();
  jQuery(".tps_colour_filter_"+filter_type).show();

  if(filter_type == 'fancy'){
    //deselect white colour filter
    $('.color_slider_wrap li').each(function() {
        $(this).removeClass('selected');
        $(this).find('input[type="checkbox"]').prop('checked', false);
    });
    $('#dia_color').val('');
  }else{
    //deselect fancy colour filter
    $('.fancy_color_slider_wrap li').each(function() {
          $(this).removeClass('selected');
          $(this).find('input[type="checkbox"]').prop('checked', false);
    });
    
    //deselect fancy intensity filter
    $('.intensity_slider_wrap li').each(function() {
          $(this).removeClass('selected');
          $(this).find('input[type="checkbox"]').prop('checked', false);
    });
    
    $('#dia_fancy_color').val('');
    $('#dia_intensity').val('');
  }
  
  if(search_type == 'white' && filter_type == 'fancy'){
    $('#diamond_type').val('natural-fancy');    
  }else if(search_type == 'white' && filter_type == 'white'){
    $('#diamond_type').val('natural-white');   
  }else if(search_type == 'lab' && filter_type == 'fancy'){
    $('#diamond_type').val('lab-fancy');    
  }else if(search_type == 'lab' && filter_type == 'white'){
    $('#diamond_type').val('lab-white');  
  }

  jQuery('#page_no').val(1);
  jQuery('#pagination').val('');   
  graphqlDataCall();
});
/*** End ***/

/*** Diamond Add To Cart Diamond Listing Page ***/
jQuery(document).on('click','.tps_addtocart',function(e){   
  var diamond_id = jQuery(this).attr("data-id");
  var diamond_image = jQuery(this).attr("data-image");  
  var diamond_type = jQuery('#diamond_type').val(); 

  jQuery(".tps_add_to_cart_loader_"+diamond_id).addClass("tps_loader_show");

  //query parameters for graphql diamond add to cart call
    var postdata = JSON.stringify({ query:`{
                    ${diamondAddToCart}(diamondId: "` +
                diamond_id +
                `",diamondType:"` +
                diamond_type +
                `")
                    {      
                      status
                       code
                       message                       
                       productId
                       variantId                       
                    }
                    }
                    `});     

       jQuery.ajax({
        url:api,
        contentType: "application/json",
        type:'POST',
        data: postdata,
        success: function(response) {  
          var variant_id = response.data.diamondAddToCart.variantId;
                  
          setTimeout(function(){ 
            
              var productSku = [];
              
              jQuery.getJSON('/cart.js', function(cart) {
               if(cart.items != '' ){                     
                 $(cart.items).each(function(index, value) { 
                     var str = "-";   
                     var sku = value.sku;

                     if(sku.indexOf(str) != -1){                  
                       sku = sku.split('-');
                       sku = sku[1];                       
                     }else{
                       var sku = value.sku;                   
                     }
                     productSku.push(sku);                                    
                 });
                                         
                 setTimeout(function(){ 
                  if($.inArray(diamond_id, productSku)!=(-1)){ 
                    alert("Product already in cart.");
                    jQuery(".tps_add_to_cart_loader_"+diamond_id).removeClass("tps_loader_show");
                  }else{                        
                    looseDiamondAddToCart(variant_id);
                  }
                }, 50);                    
               }else{
                 looseDiamondAddToCart(variant_id);
               }              
              });                                  
            
          }, 10000); 
        },
        error: function (xhr, ajaxOptions, thrownError) {
           alert(xhr.status);
           alert(thrownError);           
            jQuery(".tps_add_to_cart_loader_"+diamond_id).removeClass('tps_loader_show');
         }
      }); 
  
});

function looseDiamondAddToCart(add_id){     
  jQuery.post('/cart/add.js', {
    quantity:1,
    id: add_id,
  });
 
  setTimeout(function(){
    window.location.href = "/cart";
  }, 1000);  
  
 jQuery(".tps_add_to_cart_loader").removeClass('tps_loader_show');
}
/*** End ***/